(function () {
    'use strict';


    angular.module('swif.framework')
    .factory('swifSmsService', swifSmsService);


    /**
     * @ngdoc service
     * @name swif.framework.swifSmsService
     * @requires swif.framework.dataService
     * @requires swif.framework.collections
     * @requires swif.framework.settingsService
     * @description

     * To use the sms you just have to provide an action:
     * ```
        {
            "id": "sms",
            "title": "SMS",
            "count": "sms_message_count",
            "icon": "commenting-o",
            "visible": true,
            "available": "access_rights.openstc_full_view && access_rights.openbase_sms_template_menu",
            "btn": {
                "class": "ng-hide",
                "cancelLabel": "Close"
            },
            "modal": {
                "title": "SMS",
                "templateUrl": "partials/ui/sms_modal.html",
                "size": "lg"
            }
        }
     * ```
    */

    function swifSmsService($q, dataService, collections) {
        'ngInject';
        var service = {};

        function _getRelatedId(contentType, fieldName, id) {
            const filter = {};
            const fieldId = id ? [id] : [];
            dataService.addFilter(filter, fieldName, 'in', fieldId);
            return dataService.searchRead(contentType, filter);
        }

        function _prepareFilters(filter, ask_id, intervention_ids, task_ids) {
            dataService.addExtraFilter(filter, 'context', '|');
            dataService.addExtraFilter(filter, 'context', '&');
            dataService.addExtraFilter(filter, 'context', 'res_id', '=', ask_id);
            dataService.addExtraFilter(filter, 'context', 'model', '=', 'openstc.ask');

            dataService.addExtraFilter(filter, 'context', '|');
            dataService.addExtraFilter(filter, 'context', '&');
            dataService.addExtraFilter(filter, 'context', 'res_id', 'in', intervention_ids);
            dataService.addExtraFilter(filter, 'context', 'model', '=', 'project.project');

            dataService.addExtraFilter(filter, 'context', '&');
            dataService.addExtraFilter(filter, 'context', 'res_id', 'in', task_ids);
            dataService.addExtraFilter(filter, 'context', 'model', '=', 'project.task');
            return filter;
        }

        // Unlike Webmail modal, the SMS modal load all the SMS sent from intervention requests and their linked interventions and tasks
        // and vice versa
        service.getSmsFilter = function (item) {
            let deferred = $q.defer();
            let filter = {};

            // For intervention_request, we need to get the linked task and intervention id
            if(item._type === 'intervention_request') {
                const promises = [];
                // Get the linked tasks and interventions, 'undefined' if they are orphans: Openerp handle 'undefined' or 'false' well.
                const project_ids = _getRelatedId('intervention', 'ask_id',  item.id).then( data => data.ids);
                const task_ids = _getRelatedId('task', 'ask_id',  item.id).then(data => data.ids)
                promises.push(project_ids, task_ids);

                $q.all(promises).then(ids => {
                    filter = _prepareFilters(filter, item.id, ids[0], ids[1]);
                    deferred.resolve(filter);
                });
            } else if(item._type === 'intervention') {
                const askId = item.ask_id[0] ? item.ask_id[0] : false;
                // Try to get a linked task: task.ids[0] can be undefined if the task is orphan
                _getRelatedId('task', 'project_id', item.id).then( task => {
                    filter = _prepareFilters(filter, askId, [item.id], task.ids);
                    deferred.resolve(filter);
                });
            } else if(item._type === 'task') {
                // Get all tasks related to the ask_id OR project_id
                // ask_id & project_id can be false (orphans)
                // From project.task table, ask_id is not an array but a number

                const promises = [];
                var task_ids;
                if(item.ask_id) {
                    task_ids = _getRelatedId('task', 'ask_id',  item.ask_id).then( data => data.ids);
                    promises.push(task_ids);
                } else if (item.project_id[0]) {
                    task_ids = _getRelatedId('task', 'project_id',  item.project_id[0]).then( data => data.ids);
                    promises.push(task_ids);
                } else {
                    let defer = $q.defer();
                    defer.resolve([item.id]);
                    task_ids = defer.promise;
                    promises.push(task_ids);
                }

                $q.all(promises).then( ids => {
                    filter = _prepareFilters(filter, item.ask_id, [item.project_id[0]], ids[0]);
                    deferred.resolve(filter);
                });
            }
            return deferred.promise;
        };

        service.createSmsCollection = function (id, item) {
            /**
             * {"jsonrpc":"2.0",
             * "method":"call",
             * "params":{"model":"sms.message",
             * "fields":["to", "from", "content", "encoding", "res_id", "model_id"]}
             * @type {[type]}
             */
            return service.getSmsFilter(item).then(filter => {
                return collections.createOrUpdate(
                    id, 'sms_message', filter
                );
            });
        };

        service.createSms = function (sms, context) {
            return dataService.create('sms_message', sms, context);
        };

        service.send = function (id) {
            return dataService.call('sms_message', 'send', [[id]])
            .then(function() {
                return id;
            });
        };
        return service;
    }


})();